module.exports = __webpack_public_path__ + "static/media/un1tgroup.com.d1254feb.png";